<template>
  <div>
    <Selection class="selection" @handleChange="handleChange" />
    <div class="content">
      <div class="res-list" v-if="pagination.total > 0">
        <div class="list">
          <div class="item" @click="detail(item, true)" v-for="item in list" :key="item.id">
            <div class="cover" :class="item.type === 'model' ? 'model' : ''">
              <img :src="item.cover" alt="" srcset="" />
              <div class="modal" v-if="item.type === 'software' && item.isAuth" @click.stop>
                <div class="button" @click.stop="openApp(item)">{{ $t('resource.openSoftware') }}</div>
              </div>
            </div>
            <div class="title" @click="detail(item, true)">{{ item.name }}</div>
            <div @click="detail(item, true)" class="desc" v-if="item.Professions.length > 0">
              <span v-for="(text, index) in item.Professions" :key="index">
                {{ index === item.Professions.length - 1 ? text : text + '、' }}
              </span>
            </div>
            <div class="desc" v-else>{{ $t('resource.none') }}</div>
            <span class="type">{{ item.typeName }}</span>
          </div>
        </div>
        <Pagination class="list-pagination" :pagination.sync="pagination" @handleTableChange="handleTableChange" />
      </div>
      <NoData class="no-data" :isSearch="!!selected.keyword" v-else />
    </div>
    <Modal :visible.sync="visible" />
    <PlayerModal ref="playerModal" :playerList="playerList" @selectPlayer="selectPlayer" />
  </div>
</template>
<script>
import cookie from 'js-cookie'
import { resourceList, machineList } from '@/api/lesson'
import Modal from '@/components/XRInfoModal/index'
import NoData from '@/components/noData/index'
import Selection from '@/components/selection/index'
import Pagination from '@/components/pagination/index.vue'
import PlayerModal from '@/components/PlayerModal/index.vue'

export default {
  components: {
    Modal,
    NoData,
    Selection,
    Pagination,
    PlayerModal
  },
  data() {
    return {
      visible: false,
      checked: false,
      checkedItem: null,
      selected: {
        isAuth: false,
        resType: undefined,
        keyword: undefined,
        profession: []
      },
      list: [],
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      playerKey: '',
      playerList: []
    }
  },
  computed: {
    reversedNameMap() {
      return {
        text: this.$t('privateResource.resourceTypes.text'),
        image: this.$t('privateResource.resourceTypes.image'),
        audio: this.$t('privateResource.resourceTypes.audio'),
        video: this.$t('privateResource.resourceTypes.video'),
        model: this.$t('privateResource.resourceTypes.model'),
        software: this.$t('privateResource.resourceTypes.software')
      }
    }
  },
  methods: {
    handleTableChange() {
      this.getResourceList()
    },
    handleChange(obj) {
      console.log(obj)
      this.selected = Object.assign(this.selected, {
        isAuth: obj.isAuth,
        resType: obj.resType,
        keyword: obj.keyword,
        profession: obj.profession,
        industryId: obj.industryId,
        industryAttr: obj.industryAttr,
        machineId: obj.deviceId || undefined
      })
      if (!obj.industryId) {
        delete this.selected.industryId
      }
      this.pagination.page = 1
      this.getResourceList()
    },
    openUriWithInputTimeoutHack(url, failCb, successCb) {
      const target = document.createElement('input')
      target.style.width = '0'
      target.style.height = '0'
      target.style.position = 'fixed'
      target.style.top = '0'
      target.style.left = '0'
      document.body.appendChild(target)

      target.focus()
      const handler = this.registerEvent(target, 'blur', onBlur)

      function onBlur() {
        successCb && successCb()
        handler.remove()
        clearTimeout(timeout)
        document.body.removeChild(target)
      }

      location.href = url
      console.log('url ----->', url)

      const timeout = setTimeout(function() {
        failCb && failCb()
        handler.remove()
        document.body.removeChild(target)
      }, 1000)
    },
    registerEvent(target, eventType, cb) {
      if (target.addEventListener) {
        target.addEventListener(eventType, cb)
        return {
          remove: function() {
            target.removeEventListener(eventType, cb)
          }
        }
      } else {
        target.attachEvent(eventType, cb)
        return {
          remove: function() {
            target.detachEvent(eventType, cb)
          }
        }
      }
    },
    Ok(obj) {
      const userType = cookie.getJSON('user_type').join(',')
      const data = {
        data: Object.assign(cookie.getJSON('user_infor'), {
          resId: obj.id,
          token: localStorage.token,
          roles: cookie.getJSON('user_type'),
          type: 'openRes',
          roomId: '',
          source_type: 1, // 1校本 2个人
          school_type: userType.includes('external') ? 2 : 1, // 1校内 2校外
          deviceType: this.currentPlayer.id || '',
          player_name: this.playerName || '', // 播放器名字
          player_key: this.playerKey || '', // 播放器唯一标识符，XR根据这个参数判断打开播放器传什么样的参数
          playerId: this.playerId || '' // 播放器ID
        })
      }
      console.log('------->', data)
      // 一键打开应用程序
      // 检测用户的设备是否是Windows系统
      if (/windows|win32/i.test(navigator.userAgent)) {
        // 检测用户的浏览器是否能使用universalLink
        let openApp = false
        const userAgent = navigator.userAgent
        // 判断是否 Firefox浏览器
        if (userAgent.indexOf('Firefox') > -1) {
          openApp = true
        }
        // 判断是否 Chrome浏览器
        if (userAgent.indexOf('Chrome') > -1) {
          openApp = true
        }
        // 判断是否 Edge浏览器
        if (userAgent.indexOf('Edg') > -1) {
          openApp = true
        }
        if (openApp) {
          try {
            this.openUriWithInputTimeoutHack(
              process.env.VUE_APP_XR_NAME + '://' + encodeURIComponent(JSON.stringify(data)),
              error => {
                this.visible = true
              },
              success => {
                this.visible = false
                this.checkedItem = null
              }
            )
          } catch (err) {
            console.log(err)
            this.$message.warning(this.$t('resource.error.openSoftware'))
          }
        }
      }
    },
    async openApp(obj) {
      this.checkedItem = obj
      console.log('obj ----->', obj)
      if (obj.playerDetail && obj.playerDetail.files.length > 0) {
        const playerList = []
        const machineMap = {}
        const res = await machineList()
        if (res.code === 200) {
          res.data.list.reduce((pre, cur) => {
            pre[cur.id] = cur.icon
            return pre
          }, machineMap)
        }
        console.log('res', res, machineMap)
        obj.playerDetail.files.forEach(item => {
          item.machine.forEach((machine, inx) => {
            playerList.push({
              id: machine,
              name: item.machineName[inx] || '未知',
              icon: machineMap[machine] || require('@/assets/icons/icon_pc@2x.png'),
              checked: false
            })
          })
        })
        this.playerKey = obj.playerDetail.key
        this.playerName = obj.playerDetail.name
        this.playerId = obj.playerDetail.id
        this.playerList = playerList
        console.log('this.playerList', this.playerList)
      }
      this.$refs.playerModal.visible = true
      // this.Ok(obj)
    },
    detail(obj, open) {
      console.log('obj ----->', obj)
      // if (!obj.isAuth && obj.type !== 'software') return
      if (!open && obj.type === 'software') return
      this.checkedItem = null
      this.$router.push({
        name: 'resourceDetail',
        query: {
          id: obj.id,
          resType: 2 // type  1课程 2共享资源 3个人资源 4校级资源
        }
      })
    },
    getResourceList() {
      const data = Object.assign(this.selected, {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      })
      resourceList(data).then(res => {
        if (res.code == 200) {
          this.list = res.data.list.map(item => ({
            ...item,
            typeName: this.reversedNameMap[item.type]
          }))
          this.pagination.total = res.data.total
          this.setResourceCover()
        }
      })
    },
    setResourceCover() {
      this.list.forEach(item => {
        if (item.cover) return
        switch (item.type) {
          case 'text':
            if (!item.file || !item.file[0].format) return
            // const regex = /\.([a-zA-Z0-9]+)$/
            const match = item.file[0].format
            const bgMap = {
              ppt: 'ppt',
              pdf: 'pdf',
              doc: 'word',
              docx: 'word',
              xls: 'xlsx',
              xlsx: 'xlsx',
              pptx: 'ppt'
            }
            console.log('match', match)
            if (match) {
              item.cover = require(`@/assets/img/bg_${bgMap[match]}_cover.png`)
            } else {
              item.cover = require('@/assets/img/bg_text_cover.png')
            }
            break
          case 'audio':
            item.cover = require('@/assets/img/bg_auido_cover.png')
            break
          case 'model':
            item.cover = require('@/assets/img/bj_mx@2x.png')
            break
          case 'software':
            item.cover = require('@/assets/img/bj_sx@2x.png')
            break
        }
      })
    },
    selectPlayer(player) {
      console.log('player', player)
      this.currentPlayer = player
      this.Ok(this.checkedItem)
    }
  },
  mounted() {
    this.getResourceList()
  }
}
</script>

<style lang="less" scoped>
.selection {
  color: #000;
  padding: 22px 19px 10px 19px;
}
.content {
  position: relative;
  height: calc(100% - 167px);
  padding: 10px 19px 10px 19px;
  margin-top: 150px;
  .res-list {
    position: relative;
    height: 100%;
    .list {
      display: flex;
      flex-wrap: wrap;
      overflow-y: scroll;
      padding-right: 5px;
      max-height: calc(100% - 30px);
      // justify-content: space-between;
      .item {
        display: flex;
        cursor: pointer;
        margin-top: 22px;
        margin-right: 22px;
        position: relative;
        border-radius: 6px;
        padding-bottom: 10px;
        flex-direction: column;
        width: calc((100% - 88px) / 5);
        .cover {
          position: relative;
          margin-bottom: 6px;
          img {
            width: 100%;
            height: 172px;
            border-radius: 6px;
          }
          .modal {
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: none;
            cursor: pointer;
            border-radius: 6px;
            position: absolute;
            align-items: center;
            justify-content: center;
            background: rgba(0, 0, 0, 0.6);
            .button {
              width: 80px;
              height: 30px;
              font-size: 12px;
              font-weight: 400;
              color: #ffffff;
              line-height: 30px;
              text-align: center;
              background: linear-gradient(248deg, #ff6d00 0%, #f5a623 100%);
              box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);
              border-radius: 6px;
            }
          }
          &:hover .modal {
            display: flex;
            z-index: 9;
          }
        }
        .cover.model {
          border-radius: 6px;
          background: url('./../../assets/img/bj_model.png') no-repeat;
          background-size: 100% 100%;
          background-position: center;
        }
        .type {
          left: 0;
          top: 8px;
          min-width: 70px;
          height: 23px;
          padding: 0 5px;
          cursor: pointer;
          font-size: 11px;
          font-weight: 400;
          color: #28383b;
          line-height: 23px;
          text-align: center;
          position: absolute;
          border-radius: 0px 4px 4px 0px;
          background: linear-gradient(224deg, #eceff0 0%, #c6c9cd 100%);
        }
        .title {
          width: 100%;
          color: #000;
          font-size: 15px;
          cursor: pointer;
          overflow: hidden;
          font-weight: 550;
          line-height: 20px;
          margin-bottom: 6px;
          position: relative;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 6px 0 9px 12px;
          &::after {
            bottom: 0;
            left: 12px;
            content: '';
            width: 21px;
            height: 3px;
            opacity: 0.6;
            position: absolute;
            border-radius: 2px;
            background: #ef623d;
            box-shadow: 0px 0px 10px -2px rgba(133, 133, 133, 0.66);
          }
        }
        .desc {
          width: 100%;
          height: 20px;
          font-size: 12px;
          cursor: pointer;
          overflow: hidden;
          font-weight: 400;
          color: #000000;
          line-height: 19px;
          padding-left: 12px;
          margin-bottom: 6px;
          position: relative;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        &:nth-child(5n) {
          margin-right: 0;
        }
        &:nth-child(-n + 5) {
          margin-top: 0;
        }
      }
    }
    .list-pagination {
      width: 100%;
      bottom: 40px;
      position: absolute;
    }
  }
  .no-data {
    height: 100%;
  }
}
.item:hover {
  .title {
    color: #ff6d00 !important;
  }
}
@media screen and(min-width: 1700px) and (max-width: 1900px) {
  .content {
    .res-list {
      .list {
        .item {
          .cover {
            height: 170px;
          }
        }
      }
    }
  }
}
@media screen and(min-width: 1500px) and (max-width: 1700px) {
  .content {
    .res-list {
      .list {
        .item {
          .cover {
            img {
              height: 152px;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1400px) and (max-width: 1500px) {
  .content {
    .res-list {
      .list {
        .item {
          .cover {
            img {
              height: 126px;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1300px) and (max-width: 1400px) {
  .content {
    .res-list {
      .list {
        .item {
          .cover {
            img {
              height: 112px;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1200px) and (max-width: 1300px) {
  .content {
    .res-list {
      .list {
        .item {
          .cover {
            img {
              height: 107px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .content {
    .res-list {
      .list {
        .item {
          .cover {
            img {
              height: 79px;
            }
          }
        }
      }
    }
  }
}
</style>
